import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: "首页", href: "/" },
    { label: "赛事分类", href: "/category/jingji-saishi" },
    { label: "赛事攻略", href: "/article/1" },
    { label: "关于我们", href: "/about" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-background-50 font-bold text-lg">17</span>
            </div>
            <span className={`font-bold text-lg transition-colors ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
              每日大赛
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.href
                    ? scrolled
                      ? "bg-primary-50 text-primary-600"
                      : "bg-white/20 text-background-50"
                    : scrolled
                      ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                      : "text-background-50/80 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/jingji-saishi"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              立即参赛
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${scrolled ? "text-foreground-950" : "text-background-50"} ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <nav className="px-4 py-3 flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? "bg-primary-50 text-primary-600"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/jingji-saishi"
              className="mt-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold text-center hover:bg-primary-600 transition-colors"
            >
              立即参赛
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}